import { render, staticRenderFns } from "./BuilderAnnotationNotes.vue?vue&type=template&id=22b5734b&scoped=true&"
import script from "./BuilderAnnotationNotes.vue?vue&type=script&lang=js&"
export * from "./BuilderAnnotationNotes.vue?vue&type=script&lang=js&"
import style0 from "./BuilderAnnotationNotes.vue?vue&type=style&index=0&id=22b5734b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5734b",
  null
  
)

export default component.exports